import styled from 'styled-components'

export default styled.img`
  width: 45px;
  height: 67px;
  margin: 0px 0px 5px 25px;
  border: 0;
`;